import { Module } from '../Module';
import { GetSiteNamesRequest, IGetSiteNamesResult } from '../ServerApi/requests/GetSiteNamesRequest';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class SiteNameWithIds extends Resource<ISiteNameWithId> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetSiteNamesRequest,
      (result: IGetSiteNamesResult) => result.siteNames));
  }

}

Module.instance().service('SiteNames', SiteNameWithIds);
